// 전체동의 체크박스

function initConsent() {
  const allAgree = document.getElementById('157470-consent-3');
  const requiredAgree = document.getElementById('157470-consent-2');
  const optionalAgree = document.getElementById('157470-consent-1');

  if (!allAgree || !requiredAgree || !optionalAgree) {
    return false;
  }

  allAgree.addEventListener('change', function () {
    const checked = this.checked;

    requiredAgree.checked = checked;
    optionalAgree.checked = checked;

    requiredAgree.dispatchEvent(new Event('change', { bubbles: true }));
    optionalAgree.dispatchEvent(new Event('change', { bubbles: true }));
  });

  function updateAllAgree() {
    allAgree.checked = requiredAgree.checked && optionalAgree.checked;
  }

  requiredAgree.addEventListener('change', updateAllAgree);
  optionalAgree.addEventListener('change', updateAllAgree);

  return true;
}

const timer = setInterval(() => {
  if (initConsent()) {
    clearInterval(timer);
  }
}, 300);


